<template>
  <vxe-grid
    ref="xTableRegion"
    class="table-block"
    border
    :highlight-hover-row="true"
    resizable
    :show-overflow="true"
    height="auto"
    max-height="500"
    align="center"
    size="mini"
    :checkbox-config="{ highlight: true }"
    :radio-config="{ highlight: true }"
    :empty-render="{name: 'NotData'}"
    :toolbar-config="{ custom: false }"
    :edit-config="{ trigger: 'manual', mode: 'row' }"
    :columns="columns"
    :data="tableData"
    @cell-dblclick="cellClick"
  />
</template>

<script>
import { getArea } from '@/api/sap/common-sap'

export default {
  data() {
    return {
      columns: [
        { type: 'checkbox', title: '', field: '', width: 50 },
        { field: 'BLAND', title: '省编码', width: 120 },
        { field: 'BEZEI', title: '省描述' }
      ],
      tableData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { DATA } = await getArea()
      this.tableData = DATA
    },
    cellClick({ row, rowIndex, column }) {
      this.$refs.xTableRegion.setCheckboxRow(row, true)
    },
    submitForm() {
      return new Promise(r => {
        r(this.$refs.xTableRegion.getCheckboxRecords())
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/contract-manage/components/Region.vue